var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('dashboard-info'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8",staticStyle:{"margin-top":"-30px"}},[_c('dashboard-ticket-overview'),_c('dashboard-ticket-sold-trend-overview')],1),_c('div',{staticClass:"col-md-4",staticStyle:{"margin-top":"-30px"}},[_c('dashboard-server-overview')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }